<template>
  <div class="wrapper">
    <div class="inside">
      <div class="assign-department-wrapper">
        <div class="toggles-box">
          <div style="position: relative" class="flex-col control">
            <h3 style="margin-top: 0">
              {{ $t("profile.add_user.choose_type") }}
            </h3>

            <div class="flex checkbox-wrapper">
              <div class="form-check form-switch">
                <input
                  class="custom-radio-input"
                  type="radio"
                  id="flexSwitchCheckChecked1"
                  name="userRole"
                  @change="() => ((isAdmin = false), (isWorker = false), (isOwner = true))"
                />
                <label class="form-check-label" for="flexSwitchCheckChecked1"> {{ $t("profile.add_user.owner") }}</label>
              </div>
              <p class="role-description">{{ $t(`role_descriptions.${typeOfCompany().toLowerCase()}.owner`) }}</p>

              <div class="form-check form-switch">
                <input
                  class="custom-radio-input"
                  type="radio"
                  id="flexSwitchCheckChecked2"
                  name="userRole"
                  @change="() => ((isOwner = false), (isWorker = false), (isAdmin = true))"
                />
                <label class="form-check-label" for="flexSwitchCheckChecked2"> {{ $t("profile.add_user.admin") }}</label>
              </div>
              <p class="role-description">{{ $t(`role_descriptions.${typeOfCompany().toLowerCase()}.admin`) }}</p>

              <!-- <div class="form-check form-switch">
                <input
                  class="custom-radio-input"
                  type="radio"
                  id="flexSwitchCheckChecked3"
                  name="userRole"
                  @change="() => ((isAdmin = false), (isOwner = false), (isWorker = true))"
                />
                <label class="form-check-label" for="flexSwitchCheckChecked3"> {{ $t("profile.add_user.worker") }}</label>
              </div>
              <p class="role-description">{{ $t(`role_descriptions.${typeOfCompany().toLowerCase()}.worker`) }}</p> -->
            </div>

            <div v-show="showUsersError && !isAdmin && !isOwner && !isWorker" class="control__error role-error">
              <div class="control__error-inner">{{ $t("missings.missing_role") }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="large_box">
        <h4>{{ $t("profile.add_user.enter_worker_data") }}</h4>
        <form>
          <div class="">
            <div class="form-positioning">
              <div class="control_large control control--input">
                <label for="address" class="control__label">{{ $t("admin.profile.email") }}</label>
                <input type="text" id="address" v-model="email" />
                <div v-show="errors.email" class="control__error form-field-error">
                  <div class="control__error-inner">
                    {{ errors.email }}
                  </div>
                </div>
              </div>
              <div class="control_large control control--input">
                <label for="address" class="control__label">{{ $t("profile.add_user.phone") }}</label>
                <input @keyup="phoneNumber = phoneNumber.replace(/[^0-9+]/g, '')" id="phone-number-input" type="text" v-model="phoneNumber" />
                <div v-show="errors.phoneNumber" class="control__error form-field-error">
                  <div class="control__error-inner">
                    {{ errors.phoneNumber }}
                  </div>
                </div>
              </div>
              <div class="control_large control control--input">
                <label for="address" class="control__label">{{ $t("profile.add_user.name") }}</label>
                <input type="text" id="address" v-model="name" />
                <div v-show="errors.name" class="control__error form-field-error">
                  <div class="control__error-inner">
                    {{ errors.name }}
                  </div>
                </div>
              </div>
              <div class="control_large control control--input">
                <label for="address" class="control__label">{{ $t("profile.add_user.surname") }}</label>
                <input type="text" id="address" v-model="surname" />
                <div v-show="errors.surname" class="control__error form-field-error">
                  <div class="control__error-inner">
                    {{ errors.surname }}
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="exampleFormControlTextarea1">{{ $t("profile.add_user.message") }}</label>
                <textarea v-model="message" class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                <div v-show="errors.message" class="control__error textarea-control-error">
                  <div class="control__error-inner">
                    {{ errors.message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="buttons">
      <button class="button-outline" @click.prevent="addNewUser">
        <template v-if="!userStore.isLoading">
          {{ $t("profile.add_user.add") }}
        </template>
        <template v-else>
          {{ $t("profile.add_user.adding") }}
        </template>
      </button>
    </div>
  </div>

  <div v-if="showModal" class="dialog" id="payment-subscription-dialog">
    <div class="dialog-overlay" tabindex="-1" @click="closePaymentModal"></div>
    <div role="dialog" class="dialog-content" aria-labelledby="payment-dialog-title" aria-describedby="payment-dialog-description">
      <button @click="closePaymentModal" class="dialog-close" :aria-label="$t('admin.profile.settings.close_dialog')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      <div style="display: grid; place-items: center; padding: 20px">
        <h1 id="payment-dialog-title" class="title-with-underline" style="font-weight: 700; font-size: 24px; margin-bottom: 20px">
          {{ $t("profile.subscription_payment_title") }}
        </h1>
        <div style="text-align: center; margin-bottom: 30px">
          <p style="font-weight: 600; font-size: 16px; color: #112baf; margin-bottom: 10px">
            {{ $t("profile.worker_added_successfully", { name: justAddedWorker?.name || "", surname: justAddedWorker?.surname || "" }) }}
          </p>
          <p style="font-weight: 400; font-size: 14px; color: rgba(5, 24, 52, 0.6)">
            {{ $t("profile.subscription_payment_description") }}
          </p>
          <div style="font-weight: 600; font-size: 18px; color: rgba(5, 24, 52, 0.6); margin-top: 30px">
            {{ $t("profile.subscription_days") }}: {{ priceList[0]?.amountSubscriptionDays || "N/A" }}
          </div>
          <div style="font-weight: 600; font-size: 18px; color: rgba(5, 24, 52, 0.6)">
            {{ $t("profile.subscription_price") }}: {{ priceList[0]?.price || "N/A" }} PLN
          </div>
        </div>

        <!-- Payment Provider Selection Section -->
        <div class="payment-provider-section">
          <h2 style="font-weight: 600; font-size: 16px; text-align: center; margin-bottom: 15px; color: rgba(5, 24, 52, 0.8)">
            {{ $t("payments.choose_payment_provider") }}
          </h2>
          <div class="payment-provider-options">
            <div 
              class="payment-provider-option" 
              :class="{ active: selectedPaymentProvider === 'przelewy24' }"
              @click="selectedPaymentProvider = 'przelewy24'"
            >
              <img src="@/assets/images/przelewy.png" alt="Przelewy24" class="provider-logo" />
            </div>
            <div 
              class="payment-provider-option" 
              :class="{ active: selectedPaymentProvider === 'stripe' }"
              @click="selectedPaymentProvider = 'stripe'"
            >
              <img src="@/assets/images/stripe.png" alt="Stripe" class="provider-logo" />
            </div>
          </div>
        </div>

        <div class="payment-buttons">
          <button @click="handlePayment" class="button button--brown payment-btn" :disabled="userStore.isLoading">
            <template v-if="!userStore.isLoading">
              {{ $t("profile.pay_subscription_button") }}
            </template>
            <template v-else>
              {{ $t("profile.processing") || "Przetwarzanie..." }}
            </template>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoDepartmentScreen from "@/components/common/NoDepartmentScreen.vue";
import Menu from "@/components/Menu";
import ChangePassword from "@/components/settings/ChangePassword";
import Privacy from "@/components/settings/Privacy";
import AlertHelper from "@/helpsers/alert.helper";
import { parseError } from "@/js/error";
import storeCache from "@/js/storeCache";
import { typeOfCompany } from "@/js/utils";
import UserLayout from "@/layouts/UserLayout";
import router from "@/router";
import { useDepartmentStore } from "@/stores/department.store";
import { useHelpersStore } from "@/stores/helpers.store";
import { usePaymentStore } from "@/stores/payment.store";
import { useUserStore } from "@/stores/user.store";
import { storeToRefs } from "pinia";
import { useField, useForm } from "vee-validate";
import { computed, inject, nextTick, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import * as yup from "yup";

export default {
  name: "AddUserView",
  components: { Privacy, ChangePassword, Menu, UserLayout, NoDepartmentScreen },
  setup() {
    const userStore = useUserStore();
    const { justAddedWorker } = storeToRefs(userStore);
    const departmentStore = useDepartmentStore();
    const helpersStore = useHelpersStore();
    const paymentStore = usePaymentStore();
    const loadingPayment = ref(false)

    let { currentWarehouses } = storeToRefs(departmentStore);
    let { priceList } = storeToRefs(paymentStore);
    let width = ref(window.innerWidth);
    let loading = ref(false);
    let showDepartmentError = ref(false);
    let showUsersError = ref(false);
    let showLicenseError = ref(false);
    let alert = inject("alert");
    let chosenDepartments = ref(currentWarehouses);
    const company = storeCache.get("currentCompany");

    const showModal = ref(false);
    const selectedPaymentProvider = ref("przelewy24");

    const hasSelectedLicenses = computed(() => {
      return Object.values(selectedLicenses.value).some((license) => license.selected);
    });

    const hasActiveSubscription = () => {
      const user = storeCache.get("currentUser");
      if (!user || !user.subscriptionEndDate || user.subscriptionEndDate === null || user.hasActiveFreeTrial) {
        return false;
      }

      const subscriptionEndDate = new Date(user.subscriptionEndDate);
      const currentDate = new Date();
      const currentDatePlus24h = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000);

      return subscriptionEndDate > currentDatePlus24h;
    };

    const onLicenseToggle = (licenseType) => {
      if (!selectedLicenses.value[licenseType].selected) {
        selectedLicenses.value[licenseType].file = null;
      }
    };

    const onLicenseFileInput = (e, licenseType) => {
      const file = e.target.files[0];
      if (file) {
        if (file.size <= 10_000_000) {
          selectedLicenses.value[licenseType].file = file;
        } else {
          AlertHelper.show(alert, "Plik jest za duży. Maksymalny rozmiar to 10MB.", "", "error");
          e.target.value = "";
        }
      }
    };

    const validateLicenses = () => {
      return true;
    };

    const showPaymentModal = async () => {
      showModal.value = true;
      await nextTick();
    };

    const closePaymentModal = () => {
      showModal.value = false;

      if (userStore.clearJustAddedWorker) {
        userStore.clearJustAddedWorker();
      } else {
        userStore.justAddedWorker = null;
      }

      router.push({ name: "list-users" });
    };

    const handlePayment = async () => {
      let id = storeCache.get("currentCompany")?.id;
      const useStripe = selectedPaymentProvider.value === 'stripe';
      loadingPayment.value = true;
      await paymentStore.startTransactionForTimeWindows(
        {
          // packageId: id,
          companyId: id,
          usersId: [justAddedWorker.value.id],
          alignToBillingPeriod: true,
        },
        alert,
        useStripe
      );
      loadingPayment.value = false;

    };

    onMounted(async () => {
      let id = storeCache.get("currentCompany")?.id;
      if (id) {
        await departmentStore.fetchAllWarehouses({
          id: id,
        });
      }

      const inputBox = document.getElementById("phone-number-input");
      if (inputBox) {
        inputBox.onchange = function () {
          inputBox.value = inputBox.value.replace(/[^0-9]/g, "");
        };
      }
    });

    const { t } = useI18n();
    const { handleSubmit, errors, handleReset } = useForm({
      validationSchema: yup.object().shape({
        email: yup
          .string()
          .trim()
          .required(t("register.validation.email"))
          .email(t("register.validation.email"))
          .max(50, t("register.validation.max", { number: 50 })),
        message: yup.string().max(500, t("register.validation.max", { number: 500 })),
        name: yup
          .string()
          .trim()
          .required(t("register.validation.required"))
          .matches(/^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ-]+$/, t("register.validation.string"))
          .max(30, t("register.validation.max", { number: 30 })),
        surname: yup
          .string()
          .trim()
          .required(t("register.validation.required"))
          .matches(/^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ-]+$/, t("register.validation.string"))
          .max(50, t("register.validation.max", { number: 50 })),
        phoneNumber: yup
          .string()
          .required(t("register.validation.required"))
          .matches(
            /^(?=(.{1,20})$)((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/,
            t("register.validation.phone")
          ),
        isAdmin: yup.boolean(),
        isOwner: yup.boolean(),
        isWorker: yup.boolean(),
      }),
      initialValues: {
        email: "",
        message: "",
        name: "",
        surname: "",
        phoneNumber: "",
        isAdmin: false,
        isOwner: false,
      },
    });

    const { value: name } = useField("name");
    const { value: surname } = useField("surname");
    const { value: phoneNumber } = useField("phoneNumber");
    const { value: email } = useField("email");
    const { value: isAdmin } = useField("isAdmin");
    const { value: isOwner } = useField("isOwner");
    const { value: isWorker } = useField("isWorker");
    const { value: message } = useField("message");

    const selectedLicenses = ref({
      BF2: { selected: false, file: null },
      BF3: { selected: false, file: null },
      BF3_PLUS: { selected: false, file: null },
      BF4: { selected: false, file: null },
      VLM: { selected: false, file: null },
    });

    const addNewUser = handleSubmit(async () => {
      if (chosenDepartments.value.length > 0 || isOwner.value) {
        if (isOwner.value || isWorker.value || isAdmin.value) {
          userStore.isLoading = true;
          const data = {
            email: email.value,
            name: name.value,
            surname: surname.value,
            phoneNumber: phoneNumber.value,
            role: isAdmin.value ? "ADMINISTRATOR" : isOwner.value ? "OWNER" : isWorker.value ? "WORKER" : "",
            companyId: storeCache.get("currentCompany")?.id,
          };

          if (message.value !== "") data.message = message.value;

          try {
            await userStore.addUser(data);
            helpersStore.adjustTasks();
            userStore.isLoading = false;

            if (!isOwner.value) {
              await Promise.all(
                chosenDepartments.value.map(async (department) => {
                  const obj = {
                    alert,
                    email: email.value,
                    departmentId: department.id,
                    role: "ADMINISTRATOR",
                  };
                  return departmentStore.addWorkerToDepartment(obj, true);
                })
              );
            }

            AlertHelper.show(alert, t("profile.company.addWorker"));
            handleReset();

            if (hasActiveSubscription() && justAddedWorker.value) {
              await paymentStore.fetchSubscriptionList(storeCache.get("currentCompany")?.id, undefined, justAddedWorker.value.id);

              await showPaymentModal();
            } else {
              router.push({ name: "list-users" });
            }
          } catch (e) {
            userStore.isLoading = false;
            AlertHelper.show(alert, parseError(e), "", "error");
          }
        } else {
          showUsersError.value = true;
        }
      } else {
        showDepartmentError.value = true;
        AlertHelper.show(alert, "Przypisz pracownika do oddziału", "Aby dodać pracownika do firmy, musisz przypisać go do oddziału.", "error");
      }
    });

    const toggleDepartment = (department) => {
      if (chosenDepartments.value.includes(department)) {
        chosenDepartments.value.splice(chosenDepartments.value.indexOf(department), 1);
      } else {
        chosenDepartments.value.push(department);
      }
    };

    const isChecked = (department) => {
      return chosenDepartments.value.includes(department);
    };

    function validate(evt) {
      var theEvent = evt || window.event;
      if (theEvent.type === "paste") {
        key = event.clipboardData.getData("text/plain");
      } else {
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
      }
      var regex = /[0-9]|\./;
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }

    return {
      loading,
      validate,
      email,
      isAdmin,
      errors,
      addNewUser,
      message,
      userStore,
      isOwner,
      isWorker,
      name,
      surname,
      phoneNumber,
      currentWarehouses,
      width,
      chosenDepartments,
      showDepartmentError,
      toggleDepartment,
      typeOfCompany,
      showUsersError,
      isChecked,
      selectedLicenses,
      hasSelectedLicenses,
      onLicenseToggle,
      onLicenseFileInput,
      validateLicenses,
      showLicenseError,
      company,
      showModal,
      showPaymentModal,
      closePaymentModal,
      handlePayment,
      hasActiveSubscription,
      justAddedWorker,
      priceList,
      selectedPaymentProvider,
    };
  },
};
</script>

<style scoped lang="scss">
@use "@/css/other-screens/add-user-view.scss";

.dialog-close {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  color: #666;

  &:hover {
    color: #112baf;
  }

  svg {
    width: 20px;
    height: 20px;
  }
}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-content {
  position: relative;
  background: white;
  border-radius: 15px;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.payment-provider-section {
  width: 100%;
  margin: 20px 0;
  padding: 0 20px;
}

.payment-provider-options {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.payment-provider-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding:20px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #fff;
  min-width: 120px;
  
  &:hover {
    border-color: #112baf;
    box-shadow: 0 2px 8px rgba(17, 43, 175, 0.2);
  }
  
  &.active {
    border-color: #112baf;
    background-color: rgba(17, 43, 175, 0.05);
    box-shadow: 0 2px 8px rgba(17, 43, 175, 0.3);
  }
}

.provider-logo {
  width: 120px;
  height: 60px;
  object-fit: contain;
  margin-bottom: 8px;
}


.textarea-control-error {
  left: unset;
  bottom: unset;
}

.wrapper {
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  max-width: unset !important;
  overflow-y: auto;
  padding-bottom: 50px;
  @media screen and (max-width: 2200px) {
    flex-direction: column;
  }
  @media screen and (max-width: 850px) {
    padding: 0 20px;
  }
  overflow-x: hidden;
  .inside {
    display: flex;
    margin-top: 30px;
    max-width: 1400px;
    min-width: 1000px;
    margin: auto;
    @media screen and (max-width: 1200px) {
      min-width: 700px;
    }
    @media screen and (max-width: 1000px) {
      min-width: unset !important;
      flex-direction: column;
      align-items: center;
    }
  }
  h2,
  h3,
  h4 {
    font-weight: 600;
    color: #112baf;
    font-size: 14px;
  }
}

.checkbox-wrapper {
  gap: 10px;
  flex-direction: column;
  align-items: start;
  margin-top: 20px;
  @media screen and (max-width: 575px) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
}

.form-group label {
  font-size: 12px;
  font-weight: 400;
}

#exampleFormControlTextarea1 {
  max-width: 500px;
  font-size: 14px;
}

#exampleFormControlTextarea1:focus {
  outline: none !important;
}

.assign-department-wrapper {
  position: relative;
  top: 0px;
  width: 50%;
  @media screen and (max-width: 600px) {
    width: 90%;
  }
  h2,
  h3,
  h4 {
    margin-top: 20px;
  }
}

.toggles-box {
  margin-top: 30px;
  max-width: 500px;
  .flex-col {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
}

.make-invisible {
  opacity: 0.1;
}

input[type="checkbox"],
input[type="radio"] {
  accent-color: #112baf;
}

.primary-label {
  font-weight: 600;
  color: #112baf;
  font-size: 14px;
}

.large_box {
  min-width: unset !important;
  max-width: unset !important;
  min-height: unset !important;
  max-width: unset !important;
  width: 50%;
  max-height: 550px !important;
  h2,
  h3,
  h4 {
    margin-bottom: 10px;
  }
  @media screen and (max-width: 600px) {
    padding: 20px 0;
    width: 90%;
  }
}

.form-switch {
  padding: 0;
}

.form-switch .form-check-input {
  width: 16px;
  background-image: unset;
}

form .form-positioning label {
  font-weight: 600;
  font-size: 12px;
  color: rgba(5, 24, 52, 0.6);
}

.buttons {
  .button-outline {
    margin: 100px auto 0 auto;
    background-color: #112baf;
    color: white;

    @media screen and (max-width: 600px) {
      margin: 20px auto;
    }
  }
}

.control--input input {
  max-width: unset;
}

.return-btn-in-container {
  left: 0;
  border: 1px solid red;
}

.form-check-label {
  font-size: 14px;
  font-weight: 600;
}

.role-description {
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  margin-left: 30px;
  color: rgba(31, 34, 47, 0.6);
}

.error-departments {
  min-width: 200px;
  padding: 5px 15px;
  background-color: #f28787;
  color: #fff;
  font-size: 1.2rem;
  line-height: 15px;
  max-width: 327px;
  border-radius: 15px;
  width: 100%;
  transform: translateY(100%);
  margin-top: -20px;
  margin-bottom: 20px;
  z-index: 2;
  &-inner {
    position: relative;
  }
  &::after {
    content: "";
    position: absolute;
    top: -10px;
    left: 50%;
    display: inline-block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 15px 10px 15px;
    border-color: transparent transparent #f28787 transparent;
    transform: translateX(-50%);
  }
}

textarea {
  background: rgba(17, 43, 175, 0.04) !important;
  border: none !important;
  border-radius: 10px;
  width: 100%;
  max-width: unset !important;
}

.payment-buttons {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  max-width: 300px;

  .button {
    padding: 12px 24px;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
    font-size: 14px;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    &.button--brown {
      background-color: #112baf;
      color: white;

      &:hover:not(:disabled) {
        background-color: #0d1f87;
      }
    }

    &.button--outline {
      background-color: transparent;
      color: #112baf;
      border: 2px solid #112baf;

      &:hover:not(:disabled) {
        background-color: #112baf;
        color: white;
      }
    }
  }
}

.title-with-underline {
  text-align: center;
  color: #112baf;
  margin-bottom: 20px;
}
</style>